import { validateInn } from '@glory/kernel';

import { normalizeEmail, normalizeInn, normalizePhone } from './normalize.ts';

/** По чему нашли клиента: ИНН и почта уникальны (запрещают дубль), телефон — только предупреждение. */
export const MATCH_VIA = ['inn', 'email', 'phone'] as const;
export type MatchVia = (typeof MATCH_VIA)[number];

/** Совпадение ИНН или почты не даёт создать дубль; телефон только предупреждает. */
export const isBlockingMatch = (via: MatchVia): boolean => via !== 'phone';

export interface MatchQuery {
  readonly phone?: string | null | undefined;
  readonly email?: string | null | undefined;
  readonly inn?: string | null | undefined;
}

export type MatchKeys = Readonly<Record<MatchVia, string | null>>;

/**
 * Что искать среди клиентов: телефон, почта и ИНН в нормализованном виде. Недописанное (короткий
 * номер, ИНН с неверной суммой) не ищется — подсказка появляется, когда значение уже настоящее.
 */
export function matchKeys(query: MatchQuery): MatchKeys {
  const inn = normalizeInn(query.inn);
  return {
    inn: inn !== null && validateInn(inn) === null ? inn : null,
    email: query.email ? normalizeEmail(query.email) : null,
    phone: query.phone ? normalizePhone(query.phone) : null,
  };
}

/** Есть ли что искать. */
export const hasMatchKeys = (keys: MatchKeys): boolean => MATCH_VIA.some((via) => keys[via] !== null);
